import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import { RoomNoService } from '../service/room-no.service';
import { LanguageService } from '../service/language.service';
import { SideBar } from '../shared/component/sidebar/siderbar';
import { Subscription } from 'rxjs';

import {
  getNowDateObject,
  getStreamNowDate
} from '../shared/tools/DateNowTime';
import { nowDate } from '../index/nowDate';
import { Router } from '@angular/router';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit, OnDestroy, AfterViewInit {
  now_date = getStreamNowDate();
  now_date_obj: nowDate = getNowDateObject(
    new Date(),
    this.languageService.language
  );
  sub: Subscription[] = [];
  imgurl: string;
  appname: string;
  focusIndex = 0;
  infoIndex = 0;
  lang: 'jpn' | 'eng';
  sidebar: SideBar<InfoSideBarTiTleJpn, InfoSideBarTiTleEng>[] = [
    {
      title: 'クラブオリエンタル',
      title_jpn: 'クラブオリエンタル',
      title_eng: 'CLUB ORIENTAL',
      key_code: '1',
      checked: true,
      focused: false
    },
    {
      title: 'LINE CARD',
      title_jpn: 'LINE CARD',
      title_eng: 'LINE CARD',
      key_code: '2',
      checked: false,
      focused: false,
      onlyJapanese: true
    },
    {
      title: 'WEB接客サービス',
      title_jpn: 'WEB接客サービス',
      title_eng: 'Web customer service',
      key_code: '3',
      checked: false,
      focused: false
    },
    {
      title: 'メニューへ戻る',
      title_jpn: 'メニューへ戻る',
      title_eng: 'Back to menu',
      key_code: '92',
      checked: false,
      focused: false
    }
  ];
  constructor(
    private roomNoService: RoomNoService,
    private router: Router,
    private languageService: LanguageService,

    private el: ElementRef
  ) {}
  element: HTMLElement;

  ngAfterViewInit() {
    (<any>document.querySelector('.tab_menu_li')).focus();
  }

  ngOnInit() {
    // Languageをサービスしちゃう
    this.lang = this.languageService.language;

    if (this.languageService.language === 'eng') {
      this.imgurl = '/assets/breakfast/eng/breakfast.png';

      this.appname = 'Information';
      this.sidebar = this.sidebar.map(d => {
        d.title = d.title_eng;
        return d;
      });
    } else {
      this.imgurl = '/assets/breakfast/jpn/breakfast.png';

      this.appname = 'お知らせ';
    }
    // 現在時刻の表示
    this.sub.push(
      this.now_date.subscribe(d => {
        this.now_date_obj = getNowDateObject(d, this.languageService.language);
      })
    );
  }
  ngOnDestroy() {
    this.sub.forEach(d => d.unsubscribe());
  }

  setFocusIndex(index: number) {
    //this.controlShow = true;
    this.focusIndex = index;
    this.sidebar.forEach(d => (d.checked = false));
    this.sidebar[this.focusIndex].checked = true;
    if (index != 3) {
      this.infoIndex = index;
    }
  }

  setClickIndex(index: number) {
    //this.controlShow = true;
    if (index === 3) {
      this.router.navigate(['/room', this.roomNoService.room_no]);
    }
  }
}
type InfoSideBarTiTleJpn =
  | 'クラブオリエンタル'
  | 'LINE CARD'
  | 'WEB接客サービス';

type InfoSideBarTiTleEng =
  | 'CLUB ORIENTAL'
  | 'LINE CARD'
  | 'Web customer service';
